import { render } from "./ReceiptBlock.vue?vue&type=template&id=0ed4ed32"
import script from "./ReceiptBlock.vue?vue&type=script&lang=js"
export * from "./ReceiptBlock.vue?vue&type=script&lang=js"
script.render = render

export default script